import styled from 'styled-components'

interface IActiveCardholderAccountRequiredModalStyledProps {}

export const ActiveCardholderAccountRequiredModalStyled = styled.div<IActiveCardholderAccountRequiredModalStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
